const LearnersAccount = () => {
  return (
    <div>
      <h1>Hello</h1>
    </div>
  );
};

export default LearnersAccount;
